(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("jquery"), require("xterm")["Terminal"]);
	else if(typeof define === 'function' && define.amd)
		define("webpackNumbers", ["jquery", ["xterm","Terminal"]], factory);
	else if(typeof exports === 'object')
		exports["webpackNumbers"] = factory(require("jquery"), require("xterm")["Terminal"]);
	else
		root["webpackNumbers"] = factory(root["$"], root["Terminal"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__2__) {
return 